
import { brandLogos } from '../../../utils/images';

export default function TrustSection() {
  // Use real brand logos instead of placeholders
  const logos = brandLogos;
  return (
    <section className="py-16 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <div className="text-gray-600 text-sm font-light tracking-[0.2em] uppercase mb-4">
            Leading Manufacturers
          </div>
          <h2 className="text-4xl lg:text-6xl font-light mb-6 leading-tight">
            Trusted by global fashion brands{' '}
            <span className="font-normal">
              across North America and Europe
            </span>
          </h2>
        </div>

        {/* Client Logos Scrolling Wall */}
        <div className="border-t border-gray-200 pt-12 lg:pt-16 overflow-hidden">
          <div className="relative">
            {/* Gradient overlays for smooth edges */}
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10"/>
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10"/>

            {/* Scrolling logo container with infinite loop - faster speed */}
            <div className="flex animate-scroll hover:pause">
              {/* Original set of logos */}
              <div className="flex-shrink-0 flex items-center space-x-16 px-8">
                {logos.map((logoUrl, index) => (
                  <div key={`original-${index}`} className="flex-shrink-0 w-40 h-24 bg-white rounded-xl flex items-center justify-center">
                    <img
                      src={logoUrl}
                      alt={`Brand Logo ${index + 1}`}
                      className="max-h-16 max-w-32 object-contain"
                      onError={(e) => {
                        // If image fails to load, hide it
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                ))}
              </div>

              {/* Duplicate set for seamless loop */}
              <div className="flex-shrink-0 flex items-center space-x-16 px-8">
                {logos.map((logoUrl, index) => (
                  <div key={`duplicate-${index}`} className="flex-shrink-0 w-40 h-24 bg-white rounded-xl flex items-center justify-center">
                    <img
                      src={logoUrl}
                      alt={`Brand Logo ${index + 1}`}
                      className="max-h-16 max-w-32 object-contain"
                      onError={(e) => {
                        // If image fails to load, hide it
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
